export function onlyDigits(str: string): string {
  return str.replace(/\D/g, "");
}
